import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import {
  SECTION_NUMBER,
  SOCIAL_PROOF_QUESTION,
  socialProofMapPNG,
  socialProofMapWEBP,
  socialProofPressLogosPNG,
  socialProofPressLogosWEBP,
} from '~/pages/anatomyV2/socialProof/libs/components/AnatomyV2SocialProof/constants'
import { AnatomyV2SocialProofStyles as S } from '~/pages/anatomyV2/socialProof/libs/components/AnatomyV2SocialProof/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { selectIsLegalComplianceCountry } from '~/shared/store/user/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const AnatomyV2SocialProof = ({ pageId, nextPagePath }: TPageProps) => {
  useMatchHeaderBackground()
  const isLegalComplianceCountry = useSelector(selectIsLegalComplianceCountry)

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: SOCIAL_PROOF_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.ScrollContent>
          <SectionProgress currentSection={SECTION_NUMBER} pageId={pageId} />

          <S.Title>
            <Trans
              ns="anatomyV2"
              i18nKey="onboarding.socialProof.title"
              components={{ br: <br /> }}
            />
          </S.Title>

          <S.Quote>
            <Trans ns="anatomyV2" i18nKey="onboarding.socialProof.quote" />
          </S.Quote>

          <S.Author>
            <Trans ns="anatomyV2" i18nKey="onboarding.socialProof.author" />
          </S.Author>

          <picture>
            <source srcSet={socialProofMapWEBP} type="image/webp" />
            <S.MapImage src={socialProofMapPNG} alt="Learners worldwide map" />
          </picture>

          {!isLegalComplianceCountry && (
            <>
              <S.FeaturedLabel>
                <Trans
                  ns="anatomyV2"
                  i18nKey="onboarding.socialProof.featured"
                />
              </S.FeaturedLabel>

              <picture>
                <source srcSet={socialProofPressLogosWEBP} type="image/webp" />
                <S.PressLogosImage
                  src={socialProofPressLogosPNG}
                  alt="Featured in USA Today, Forbes, WSJ, New York Post, Mashable"
                />
              </picture>
            </>
          )}
        </S.ScrollContent>

        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            onClick={() => handleContinue('continue')}
          >
            <Trans i18nKey="actions.continue" />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AnatomyV2SocialProof
